// Preferências de aparência do usuário (no navegador): estilo de menu + zoom.
// Centralizado pra Layout e Configurações ficarem em sincronia via evento.

export type MenuEstilo = 'padrao' | 'flutuante' | 'topo'
export type DashEstilo = 'padrao' | 'executivo' | 'compacto'

const K_MENU = 'velore_menu_estilo'
const K_ZOOM = 'velore_zoom'
const K_DASH = 'velore_dash_estilo'
export const EVT = 'velore-aparencia'

export const DASH_ESTILOS: { id: DashEstilo; nome: string; desc: string }[] = [
  { id: 'padrao', nome: 'Padrão', desc: 'Visão completa com KPIs, gráficos e listas.' },
  { id: 'executivo', nome: 'Executivo', desc: 'Hero com gradiente e números grandes — foco no resultado.' },
  { id: 'compacto', nome: 'Compacto', desc: 'Tudo mais denso — cabe mais na tela.' },
]

export function getDashEstilo(): DashEstilo {
  try {
    const v = localStorage.getItem(K_DASH) as DashEstilo | null
    return v === 'executivo' || v === 'compacto' ? v : 'padrao'
  } catch { return 'padrao' }
}

export function setDashEstilo(v: DashEstilo) {
  try { localStorage.setItem(K_DASH, v) } catch {}
  window.dispatchEvent(new Event(EVT))
}

export const MENU_ESTILOS: { id: MenuEstilo; nome: string; desc: string }[] = [
  { id: 'padrao', nome: 'Padrão', desc: 'Menu lateral clássico (recolhe/fixa).' },
  { id: 'flutuante', nome: 'Flutuante', desc: 'Painel lateral flutuante, arredondado e elegante.' },
  { id: 'topo', nome: 'Barra no topo', desc: 'Menu horizontal no topo, conteúdo em tela cheia.' },
]

export function getMenuEstilo(): MenuEstilo {
  try {
    const v = localStorage.getItem(K_MENU) as MenuEstilo | null
    return v === 'flutuante' || v === 'topo' ? v : 'padrao'
  } catch { return 'padrao' }
}

export function setMenuEstilo(v: MenuEstilo) {
  try { localStorage.setItem(K_MENU, v) } catch {}
  window.dispatchEvent(new Event(EVT))
}

export function getZoom(): number {
  try {
    const n = parseInt(localStorage.getItem(K_ZOOM) || '100', 10)
    return Number.isFinite(n) ? Math.min(130, Math.max(70, n)) : 100
  } catch { return 100 }
}

export function setZoom(n: number) {
  const v = Math.min(130, Math.max(70, Math.round(n)))
  try { localStorage.setItem(K_ZOOM, String(v)) } catch {}
  aplicarZoom(v)
  window.dispatchEvent(new Event(EVT))
}

export function aplicarZoom(n?: number) {
  const v = n ?? getZoom()
  try {
    const root = document.documentElement
    ;(root.style as any).zoom = v === 100 ? '' : `${v}%`
    // BUG: a propriedade CSS `zoom` quebrava elementos que dependem do viewport:
    //  - alturas 100vh (sidebar) viravam 100vh*zoom → barra estourava/encolhia;
    //  - a bolinha da Sofia (position:fixed posicionada por JS) usa innerWidth
    //    físico, que não bate com o sistema de coordenadas zoomado.
    // FIX (26/06): expomos o fator como var CSS `--zoom` pra os elementos de
    // viewport compensarem com calc(100vh/var(--zoom)) e o JS da Sofia dividir
    // innerWidth/innerHeight pelo fator. Default 1 quando sem zoom.
    root.style.setProperty('--zoom', String(v / 100))
  } catch {}
}
